import {useRouteError} from "react-router-dom";
import {Alert, AlertDescription, AlertIcon, AlertTitle, Box} from "@chakra-ui/react";
import React from "react";

export default function NotFoundPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <Box mt={10}>
      <Alert
        borderRadius={10}
        status='error'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        textAlign='center'
        height='200px'
      >
        <AlertIcon boxSize='40px' mr={0}/>
        <AlertTitle mt={4} mb={1} fontSize='lg'>
          404
        </AlertTitle>
        <AlertDescription maxWidth='sm'>
          No se ha encontrado la página que buscas
        </AlertDescription>
      </Alert>
    </Box>
  );
}